import { ClaimReason } from 'src/types'

import { GenerateQueriesArgs, generateQueries } from '../../queryGenerator'

export const CLAIM_REASONS_ENDPOINT = 'claim_reasons'
export const CLAIM_REASONS_QUERY_KEY = 'claimReasons'

const config: GenerateQueriesArgs<ClaimReason> = {
  endpoint: CLAIM_REASONS_ENDPOINT,
  queryKey: CLAIM_REASONS_QUERY_KEY,
  useAllEntitiesQueryArgs: {
    queryOptions: {
      cacheTime: 1000 * 60 * 120,
      staleTime: 1000 * 60 * 60,
    },
  },
}

export const { useAllEntitiesQuery: useClaimReasonsQuery } = generateQueries(config)
